// Modify this accordingly  
export const paymentTypes = ["ACH", "Autopay", "Avid", "Check", "CO", "NP", "OP"]

// Vendor payment methods that export automatically in their ACH color format. They are listed under the ACH tab.
export const achColorMethods = ["ACH Green", "ACH Peach", "ACH Light Blue", "ACH Pink", "ACH Purple", "ACH Red"]

// Today's batches tab a payment method is listed under
export const tabForPaymentMethod = (method) => (achColorMethods.includes(method) ? "ACH" : method)